<template>
  <div v-if="loading" class="row">
    <div class="col-12 text-center mt-5 mb-5">
      <b-spinner
        variant="primary"
        type="grow"
        :label="`${this.$t('reports.loadingLabel')}...`"
      ></b-spinner>
    </div>
  </div>
  <div v-else>
    <div class="row">
      <div class="col-12 select-area">
        <b-form-group
          label="Pergunta"
          label-for="select-profile"
        >
          <b-form-select
            id="select-profile"
            v-model="selectedMainQuestion"
            :options="optionsMainQuestion"
            @change="listOptions"
          ></b-form-select>
        </b-form-group>
        <b-form-group
          label="Opção"
          label-for="select-option"
          v-if="selectedMainQuestion && optionsOptions.length > 1"
        >
          <b-form-select
            id="select-option"
            v-model="selectedOption"
            :options="optionsOptions"
            @change="listSubOptions"
          ></b-form-select>
        </b-form-group>
        <b-form-group
          v-if="selectedOption && optionsSubOptions.length > 1"
          label="Sub Opção"
          label-for="select-suboption"
        >
          <b-form-select
            id="select-suboption"
            v-model="selectedSubOptions"
            :options="optionsSubOptions"
          ></b-form-select>
        </b-form-group>
        <b-form-group v-if="selectedOption" class="pt30">
          <b-button
            id="analyze-button"
            @click="analyzeChart"
            :title="`${$t('reports.comparativeCategories.analyzeLabel')}`"
          >
            {{ $t('reports.comparativeCategories.analyzeLabel') }}
          </b-button>
        </b-form-group>
      </div>
      <div>
        <template v-for="(tagItem, index) in tagsFilters">
          <idx-chips :key="index" style="margin-left: 24px">
            <span
              >{{ tagItem.question[0].toUpperCase() + tagItem.question.substr(1) }}-{{ tagItem.option }}-{{
                tagItem.subOption
              }}</span
            >
            <span class="closebtn" @click="handleRemoveTag(index)"
              >&times;</span
            >
          </idx-chips>
        </template>
      </div>
    </div>
    <div v-if="tagsFilters.length === 0" class="row">
      <div class="col-12 text-center mt-4">
        <p>
          <font-awesome-icon
            :icon="['fas', 'chart-line']"
            style="margin-right: 20px; font-size: 35px"
          />
        </p>
        <h5>
          {{ this.$t('reports.comparativeCategories.reportTitleMultiple') }}
        </h5>
        <p>{{ this.$t('reports.comparativeCategories.fillFieldsMsg') }}</p>
      </div>
    </div>
    <div v-else class="row">
      <div class="col-12 mt-4">
        <highcharts v-if="!loadingReport" :options="chartOptions"></highcharts>
        <div v-else class="col-12 text-center mt-5 mb-5">
          <b-spinner
            variant="primary"
            type="grow"
            :label="`${this.$t('reports.loadingLabel')}...`"
          ></b-spinner>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { isBefore } from 'date-fns';
import api from '../../../../services/api';
import idxChips from '../../../molecules/idx-chips';
import eventBus from '../../../../eventBus';

export default {
  components: {
    idxChips,
  },
  props: ['accumulated', 'reportPeriod'],
  data: () => ({
    loading: true,
    userAuth: null,
    emptyState: true,
    period: 'daily',
    selectedMainQuestion: null,
    optionsMainQuestion: [],
    selectedOption: null,
    optionsOptions: [],
    selectedSubOptions: null,
    optionsSubOptions: [],
    selectedTags: [],
    chartOptions: {},
    yAxisTitle: null,
    chartsValues: [],
    tagsFilters: [
    ],
    notFoundTag: true,
    loadingReport: true,
    listInfoGraph: [],
    listMainQuestions: []
  }),

  computed: {
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('companies', ['myMetric']),
    ...mapState('branches', [
      'myIh1',
      'myIh2',
      'myHierarchies1',
      'myHierarchies2',
    ]),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.changeLabels();
    this.changeYAxisTitle();
  },

  async mounted() {
    this.loading = false;
    eventBus.$on('accumulated-report', (checked) => {
      this.accumulated = checked;

      const data = this.listInfoGraph;

      this.chartOptions.xAxis.categories = data.categories;

      if (this.accumulated) {
        this.chartOptions.series = data.npsAccumulated;
      } else {
        this.chartOptions.series = data.nps;
      }
    });
    eventBus.$on('data-source', () => {
      this.getInfoGraph();
    });
    eventBus.$on('changedLanguage', () => {
      this.changeLabels();
    });
  },

  methods: {
    listOptions(){
      this.getOptions();
    },

    async getMainQuestion() {
      const resp = await api.get(
        `addquestion/MULTIPLE`,
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            actionId:
              this.myActionsIds.length === 0
                ? null
                : this.myActionsIds.join(','),
            groupId: this.actionGroupData._id ? this.actionGroupData._id : null,
          },
        },
      );

      this.optionsMainQuestion.push({
        text: 'Selecione uma pergunta',
        value: null,
      });

      this.optionsMainQuestion.push(...resp.data.listAddQuestion);

      this.listMainQuestions.push(...resp.data.listAddQuestion);
    },

    changeLabels() {
      this.getMainQuestion();

      this.chartOptions = {
        chart: {
          type: 'line',
        },
        title: {
          text: this.$t('reports.comparativeN1N2.title'),
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: this.yAxisTitle,
          },
        },
        plotOptions: {
          line: {
            dataLabels: {
              enabled: true,
            },
            enableMouseTracking: false,
          },
        },
        series: [],
      };
    },

    clearFieldsSelected() {
      this.selectedMainQuestion = null;
      this.selectedOption = null;
      this.selectedSubOptions = null;
    },

    async listSubOptions() {
      if (this.selectedOption) {
        try {
          const resp = await api.get(
            `/addquestion/${this.selectedMainQuestion}/subOptions`,
            {
              headers: {
                'x-access-token': this.userAuth.token,
              },
              params: {
                actionId:
                  this.myActionsIds.length === 0
                    ? null
                    : this.myActionsIds.join(','),
                groupId: this.actionGroupData._id ? this.actionGroupData._id : null,
                optionText: this.selectedOption,
              },
            },
          );

          this.optionsSubOptions = [];

          this.optionsSubOptions.push(
            {
              value: null,
              text: 'Selecione uma sub opção',
            },
          );

          this.optionsSubOptions.push(...resp.data.subChoices)
        } catch (error) {
          window.console.log(error);
        }
      }
    },

    async getOptions() {
      this.optionsOptions = [];

      try {
        const resp = await api.get(`/addquestion/${this.selectedMainQuestion}/options`, {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            actionId:
              this.myActionsIds.length === 0
                ? null
                : this.myActionsIds.join(','),
            groupId:
              this.actionGroupData._id
                ? this.actionGroupData._id
                : null,
          },
        });

        this.optionsOptions = [
          {
            value: null,
            text: 'Selecione uma opção',
          },
        ];

        this.optionsOptions.push(...resp.data.choices);
      } catch (error) {
        window.console.log(error);
      }
    },

    tagSubOreturnTagNameOptionAndSubOption(type, id) {
      if (type === 'option') {
        if (id) {
          const option = this.optionsOptions.find(
            (obj) => obj.value === id,
          );

          if (option !== undefined) {
            return option;
          }
          return 'Todos';
        }
        return 'Todos';
      } else if (type === 'subOption') {
        if (id) {
          const subOption = this.optionsSubOptions.find(
            (obj) => obj.value === id,
          );

          if (subOption !== undefined) {
            return subOption;
          }
          return 'Todos';
        }

        return 'Todos';
      }

      return 'Todos';
    },

    returnGrayTags() {
      if (this.tagsFilters.length > 0) {
        for (let i = 0; i < this.tagsFilters.length; i += 1) {
          if (
            this.selectedMainQuestion === this.tagsFilters[i].mainQuestionId &&
            this.selectedOption === this.tagsFilters[i].option &&
            this.selectedSubOptions === this.tagsFilters[i].subOption
          ) {
            this.notFoundTag = false;
          }
        }
      }

      if (this.notFoundTag) {
        const tagOption = this.tagSubOreturnTagNameOptionAndSubOption(
          'option',
          this.selectedOption,
        );
        const tagSubOption = this.tagSubOreturnTagNameOptionAndSubOption(
          'subOption',
          this.selectedSubOptions,
        );

        const mainQuestion = this.listMainQuestions.find((item) => item.value === this.selectedMainQuestion);

        this.tagsFilters.push({
          mainQuestionId: mainQuestion.value ? mainQuestion.value : 'sem-id',
          question: mainQuestion.text ? mainQuestion.text : 'Todos',
          option: tagOption.text ? tagOption.text : tagOption,
          // idCategory: tagOption.value ? tagOption.value : null,
          subOption: tagSubOption.text
            ? tagSubOption.text
            : tagSubOption,
          // idSubCategory: tagSubOption.value ? tagSubOption.value : null,
        });
      }
    },

    async getInfoGraph() {
      this.loadingReport = true;
      const res = await api.get(
        `/reports/comparative-additional-questions`,
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            indicator: this.indicatorName,
            indicatorValue: this.indicatorData.value,
            indicatorRange: this.indicatorData.range,
            actionId:
              this.myActionsIds.length === 0
                ? null
                : this.myActionsIds.join(','),
            metric: this.myMetric ? this.myMetric : null,
            startDate: this.calendarDates.start
              ? this.calendarDates.start
              : null,
            endDate: this.calendarDates.end ? this.calendarDates.end : null,
            ih1:
              this.myHierarchies1.length === 0
                ? null
                : this.myHierarchies1.join(','),
            ih2:
              this.myHierarchies2.length === 0
                ? null
                : this.myHierarchies2.join(','),
            groupId: this.actionGroupData._id,
            tagsFilters: this.tagsFilters,
            period: this.reportPeriod
          },
        },
      );
      this.listInfoGraph = res.data;

      this.chartOptions.xAxis.categories = this.listInfoGraph.categories;

      if (this.accumulated) {
        this.chartOptions.series = this.listInfoGraph.npsAccumulated;
      } else {
        this.chartOptions.series = this.listInfoGraph.nps;
      }

      this.loadingReport = false;
    },

    async analyzeChart() {
      this.listSubOptions();
      this.returnGrayTags();

      if (this.notFoundTag) {
        this.getInfoGraph();
      }

      this.selectedOption = null;
      this.selectedSubOptions = null;
      this.selectedMainQuestion = null;
    },

    getOptionName(id) {
      for (let i = 0; i < this.optionsOptions.length; i += 1) {
        if (id === this.optionsOptions[i].value) {
          return this.optionsOptions[i].text;
        }
      }
      return '';
    },

    getSubOptionName(id) {
      for (let i = 0; i < this.optionsSubOptions.length; i += 1) {
        if (id === this.optionsSubOptions[i].value) {
          return this.optionsSubOptions[i].text;
        }
      }
      return '';
    },

    getTagInfo(tag) {
      // let retText = '';
      // if (tag && tag.profile) {
      //   retText = `${retText}${this.getProfile(tag.profile)} - `;
      // } else {
      //   retText = `${retText}${this.$t(
      //     'reports.comparativeCategories.allLabel',
      //   )} - `;
      // }
      // if (tag && tag.category) {
      //   retText = `${retText}${this.getOptionName(tag.category)} - `;
      // }
      // if (tag && tag.subcategory) {
      //   retText = `${retText}${this.getSubOptionName(tag.subcategory)}`;
      // } else {
      //   retText = `${retText}${this.$t(
      //     'reports.comparativeCategories.allLabel',
      //   )}`;
      // }
      // return `${retText}`;
    },

    handleRemoveTag(index) {
      this.tagsFilters.splice(index, 1);
      this.getInfoGraph();
    },

    updateChartCategories() {},

    updateChartSeries() {},

    convertDate(date) {
      const dates = date.split('/');
      return `${dates[1]}/${dates[0]}/${dates[2]}`;
    },

    changeYAxisTitle() {
      this.yAxisTitle = `%${this.$t(
        'reports.comparativeN1N2.yAxisLabel',
      )}`;
      this.chartOptions.yAxis.title.text = this.yAxisTitle;
    },
  },

  watch: {
    tagsFilters: async function watchTagFilters() {
      // this.getInfoGraph();
    },

    actionGroupData: async function watchActionGroupData() {
      this.clearFieldsSelected();
      this.getInfoGraph();
    },

    myActionsIds: async function watchMyActionsIds() {
      this.clearFieldsSelected();
      this.getOptions();
      this.getInfoGraph();
    },

    myIh1: async function watchMyIh1() {
      this.clearFieldsSelected();
      this.getInfoGraph();
    },

    myHierarchies1: async function watchMyHierarchies1() {
      this.clearFieldsSelected();
      this.getInfoGraph();
    },

    myHierarchies2: async function watchMyHierarchies2() {
      this.clearFieldsSelected();
      this.getInfoGraph();
    },

    myIh2: async function watchMyIh2() {
      this.clearFieldsSelected();
      this.getInfoGraph();
    },

    calendarDates: async function watchDates() {
      this.clearFieldsSelected();
      this.getInfoGraph();
    },

    myMetric: async function watchMyMetric() {
      this.clearFieldsSelected();
      this.changeYAxisTitle();
      this.getInfoGraph();
    },
    'indicatorData.value': async function watchIndicatorDataValue() {
      this.clearFieldsSelected();
      this.getInfoGraph();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      this.clearFieldsSelected();
      this.getInfoGraph();
    },
  },

  beforeDestroy() {
    eventBus.$off('accumulated-report');
    eventBus.$off('data-source');
  },
};
</script>

<style scoped lang="scss">
.select-area {
  display: flex;
  flex-direction: row;

  select {
    width: 215px;
    margin-right: 15px;
  }
}
.pt30 {
  padding-top: 30px;
}
#analyze-button {
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/comparative-n1-n2/index.vue